<template>
  <main class="wrapper-content">
    <h1>{{ $t('Clientes api') }}</h1>
    <b-row v-if="!isLoading">
      <LmTextInput
        class="col-md-6 col-12"
        placeholder="Client Id"
        label="Client Id"
        v-model="$v.clientId.$model"
        :v="v('clientId')"
      />
      <LmTextInput
        v-if="!isOnEditMode"
        class="col-md-6 col-12"
        placeholder="Se genera automáticamente al guardar"
        label="Client Secret"
        disabled
      />

      <LmPassword
      v-else
        class="col-md-6 col-12"
        placeholder="Client Secret"
        label="Client Secret"
        v-model="clientSecret"
      />

      <LmButton
        class="col-auto"
        buttonClass="btn-secondary"
        :value="$t('go_back')"
        :isProcessing="isProcessing"
        @click="onCancel"
      />
      <LmButton
        class="col-auto"
        buttonClass="btn-primary"
        :value="$t('save')"
        :isProcessing="isProcessing"
        @click="onSubmit"
      />
      <LmButton
        v-if="isOnEditMode && !deleted"
        class="col-auto"
        :requireConfirmation="true"
        :confirmationTitle="$t('you_are_about_to_delete_the_profile_group')"
        buttonClass="btn-danger"
        :value="$t('delete')"
        :isProcessing="isProcessing"
        @click="onDelete"
      />
      <LmButton
        v-if="isOnEditMode && deleted"
        value="Reactivar"
        class="col-auto"
        :requireConfirmation="true"
        :confirmationTitle="$t('you_are_about_to_reactivate_the_profile_group')"
        buttonClass="btn-success"
        :isProcessing="isProcessing"
        @click="onReactivate()"
      />
      <LmButton
        v-if="isOnEditMode"
        class="col-auto"
        buttonClass="btn-info"
        :value="$t('Nuevo Client Secret')"
        :isProcessing="isProcessing"
        @click="onNewClientSecret"
      />
    </b-row>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
    </b-row>
  </main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'
import LmDataTable from '@/components/lmDataTable/table'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput,
    LmButton,
    LmTreeSelect,
    LmDataTable,
    LmPassword
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      clientId: '',
      clientSecret: '',
      deleted: false,
      isProcessing: false
    }
  },
  validations: {
    clientId: { required }
  },
  methods: {
    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    async onNewClientSecret () {
      try {
        this.isProcessing = true
        const res = await commonsApi.axiosPutWrapper(`/oauthclients/update_client_secret/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('Client Secret ha cambiado exitosamente')}`, `${this.$t('Client Secret ha cambiado exitosamente')}`)
        this.clientSecret = res.data.clientSecret
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        this.isProcessing = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/oauthclients/${this.$route.params.id}`, {
            clientId: this.clientId
          })
        } else {
          const res = await commonsApi.axiosPostWrapper('/oauthclients/', {
            clientId: this.clientId
          })
          this.$router.replace(`/clientes-api/editar/${res.data._id}`)
        }
        this.lmToastSuccessMessage(
          `${this.$t('profile_group_saved_successfully')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/oauthclients/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('profile_group_was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/oauthclients/reactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('the_profile_group_was_successfully_reactivated')}`, `${this.$t('it_was_successfully_reactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/oauthclients/${this.$route.params.id}`)
      this.clientId = res.data.clientId
      this.clientSecret = res.data.clientSecret
      this.deleted = res.data.deleted
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
